import { connect } from 'react-redux';
import { RootState } from 'src/store';

export default connect((state: RootState) => ({
  timeZoneOffset: state.timezone.selectedZone.offset,
}));
